import { useState, useEffect } from 'react';

function useDebugGrid(defaultValue?: boolean, ignoreKeyboard?: boolean) {
  const [debugGrid, setDebugGrid] = useState<boolean>(!!defaultValue);

  useEffect(() => {
    setDebugGrid(!!defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    // Little "hack" to allow logged in staff users to toggle debug mode on production
    const isCrehanaStaff = window.__INITIAL_STATE__?.user?.isStaff;
    const shouldAddListener =
      typeof document !== 'undefined' &&
      !ignoreKeyboard &&
      (process.env.NODE_ENV !== 'production' ||
        process.env.ENABLE_CREHUI_DEBUG ||
        isCrehanaStaff);

    const listener = (event: HTMLElementEventMap['keydown']) => {
      if (
        event.ctrlKey &&
        event.shiftKey &&
        (event.code === 'Digit4' || event.code === 'Numpad4')
      ) {
        setDebugGrid(prevDebugGrid => !prevDebugGrid);
      }
    };

    if (shouldAddListener) {
      document.addEventListener('keydown', listener);
    }

    return () => {
      if (shouldAddListener) {
        document.removeEventListener('keydown', listener);
      }
    };
  }, [ignoreKeyboard]);

  return debugGrid;
}

export default useDebugGrid;
